import { DeleteProductRequest } from '@/api/product/types';
import ProductApiService from '@/api/product';
import useGoogleAnalytics from '@package/hooks/src/useGoogleAnalytics';
import { apiClient } from '@/services/base';

const productApiService = new ProductApiService(apiClient);
const { removeProductFromCart } = useGoogleAnalytics();

export default function useDeleteProduct() {
  const deleteProduct = async (data: DeleteProductRequest) => {
    try {
      await productApiService.deleteProduct(data);
      removeProductFromCart({ product: data.product });
    } catch (error) {
      console.error('Failed to delete product:', error);
    }

    return {
      deleteProduct,
    };
  };
  return { deleteProduct };
}
